var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { fontWeight, mq, breakpoints } from "core/styles/snippets";
import { QuotedText } from "core/components/QuotedText";
export var QuotedTitle = function (_a) {
    var children = _a.children;
    return (React.createElement(StyledQuotedText, { variant: "big" },
        React.createElement(BigTitle, null, children)));
};
var StyledQuotedText = styled(QuotedText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1.8125rem;\n\n  ", " {\n    margin-bottom: 3rem;\n  }\n"], ["\n  margin-bottom: 1.8125rem;\n\n  ", " {\n    margin-bottom: 3rem;\n  }\n"])), mq.minWidth(breakpoints.portrait));
export var BigTitle = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1.5rem;\n  margin: 0;\n  ", ";\n\n  ", " {\n    font-size: 2rem;\n  }\n\n  strong {\n    ", ";\n  }\n"], ["\n  font-size: 1.5rem;\n  margin: 0;\n  ", ";\n\n  ", " {\n    font-size: 2rem;\n  }\n\n  strong {\n    ", ";\n  }\n"])), fontWeight.regular, mq.minWidth(breakpoints.portrait), fontWeight.extraBold);
var templateObject_1, templateObject_2;
